<template>
    <div class="wrap">
        <!-- 头部 -->
        <headTop :toggle="5"></headTop>
        <!-- 中间内容 -->
        <div class="specialistContent">
            <div style="padding:0.2em 3em 0em 3em">
                <div class="box">
                    <div class="specialistContent_left">
                        <div class="specialistContent_left_title" @click="changeDetail()">云课堂</div>
                        <div
                                class="bG"
                                v-for="(item, index) in leftMenu1"
                                :key="index"
                                :class="{ active: toggle == item.comments }"
                                @click="changeDetail(item)"
                        >
                            {{ item.comments }}
                        </div>
                    </div>


                    <div class="specialistContent_right">
                        <div class="specialistContent_right_title">
                            <div class="title">云课堂{{current}}</div>
                        </div>
                        <ul class="listBox">
                            <li
                                    class="cursorPointer"
                                    v-for="item in listArr"
                                    :key="item.createTime"
                                    @click="pageTO(item)"
                            >
                                <img :src="$store.getters.imgUrl+item.logo"/>
                                <span class="listBox-text">{{item.title}}</span>
                            </li>
                            <li v-show="listArr.length%4>0" v-for="item in (4-listArr.length%4)" :key="item"></li>
                        </ul>
                        <div class="pagination-wrapper">
                            <Pagination :total="total*1" @change="changePagination"></Pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <footCode></footCode>
            </div>
        </div>
    </div>
</template>
<script>
    import footCode from "../../components/footCode";
    import headTop from "../../components/HeadTop";
    import Pagination from "@/components/pagination";

    export default {
        name: "cloudClassroom",
        components: {
            footCode,
            headTop,
            Pagination,
        },
        data() {
            return {
                listArr: [],
                total: "", // 条数
                current: "", // 第几页
                limit: 12,
                page: 1,
                leftMenu1: [], // 左侧菜单数据
                toggle: "云课堂", // 当前选中的菜单项
                mode: {
                    page: 1,
                    limit: 12,
                    officeId: "",
                },
                scrollTop:"",
            };
        },
        mounted() {
            this.getLeftList()
            this.indexInit();
        },
        methods: {
            indexInit() {
                // 云课堂分页
                this.ajaxUtil({
                    method: "get",
                    // url: '/apiAjax/api/home/index',
                    url:
                        this.$store.state.axiosUrl +
                        `/api/home/getCloudClassPage?limit=${this.limit}&page=${this.page}&category=${this.mode.officeId}`,
                    // params: {},
                }).then((res) => {
                    console.log(res);
                    this.listArr = res.data;
                    this.total = res.count;
                });
            },
            pageTO(_item) {
                // 新页打开
                console.log(_item.fileUrl);
                if (_item.fileUrl) window.open(_item.fileUrl);
            },
            changePagination(current) {
                // 第几页
                this.page = current;
                this.indexInit()
            },
            changeDetail(item) {
                // 左侧菜单点击处理
                if (item) {
                    this.toggle = item.comments;
                    this.page = 1;
                    this.mode.officeId = item.paramKey;
                    this.indexInit();
                }else {
                    this.toggle = '';
                    this.page = 1;
                    this.mode.officeId = '';
                    this.indexInit();
                }
            },

            getLeftList() {
                this.ajaxUtil({
                    method: "get",
                    // url: '/apiAjax/api/home/index',
                    url: this.$store.state.axiosUrl + "/api/home/getAllCloudClassRoomLeft",
                }).then((res) => {

                    // let a = res.data.filter((item) => {
                    //     return item.type == 1;
                    // });
                    // let b = res.data
                    //     .filter((item) => {
                    //         return item.type == 2;
                    //     })
                    //     .splice(0, 2);
                    // this.leftMenu1 = [...a, ...b];
                    this.leftMenu1 = res.data;
                    this.mode.officeId = res.data[0].paramKey;
                    // this.getDetail();
                });
            },

        },
    };
</script>
<style scoped lang="less">
    @import url("~@/assets/css/index.less");

    .wrap {
        display: flex;
        flex-direction: column;
        min-width: 12.8em;
    }

    .specialistContent {
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: space-between;
        min-height: 110vh;
        // overflow: auto;
        .specialistContent_right {
            color: #333;
            margin-left: 2em;
            margin-top: 0.1em;
            font-size: 0.18em;
            flex: 1;

            .specialistContent_right_title {
                font-size: 0.2em;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-top: 1em;
                border-bottom: 1px solid #e5e5e5;

                div {
                    padding-bottom: 1em;
                }

                .title {
                    color: #2579bf;
                    font-size: 16px;
                    padding-bottom: 5px;
                    border-bottom: 4px solid #2579bf;
                }
            }

            //   列表
            .listBox {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;

                li {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    position: relative;
                    width: 22%;
                    margin-top: 20px;

                    img {
                        width: 100%;
                        height: 8em;
                        border-radius: 5px;
                    }

                    span {
                        font-size: .84em;
                        color: @color3;
                        padding: 15px 10px 0;
                        .ellipsis;
                    }
                }
            }

            .pagination-wrapper {
                margin-top: 30px;
                margin-bottom: 80px;
            }
        }
    }

    .footer {
        width: 100%;
        // margin-top: 0.2em;
    }

    .titlePosition {
        font-size: 0.15em;
        display: flex;
        justify-content: flex-end;
        width: 100%;
        color: #666;
    }

    .box {
        height: 100%;
        display: flex;
    }

    .specialistContent_left {
        font-size: 0.17em;
        color: #333;

        div {
            padding: 0.2em 1em;
            height: 2.5em;
            text-align: center;
            background-color: #d6f0f6;
            margin-top: 0.08em;
            cursor: pointer;
            font-size: 0.85em;
            width: 240px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .specialistContent_left_title {
            background: radial-gradient(circle, #3cc9e4 0%, #2579bf 100%);
            color: #fff;
            padding: 0.6em;
            //   width: 15em;
            font-size: 1em;
        }

        .bG:hover {
            color: #2579bf;
            background-color: #fff;
        }

        .active {
            color: #2579bf;
            background-color: #fff;
            border-left: 0.5em solid #2579bf;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/cloudClassroom/index.vue